import React from 'react';
import { Container } from 'components/UI';
import { Icon, Markup, Title } from '@landing/ui';
import LocationMap from './LocationMap/LocationMap';

import * as styles from './Location.module.scss';

export default function Location({ title, date, address }) {
  return (
    <Container id="address" background="transparent" className={styles.container}>
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <section className={styles.info}>
          <div className={styles.infoItem}>
            <Icon name="clock" className={styles.infoIcon} />
            <span className={styles.infoDescription}>{date}</span>
          </div>
          <div className={styles.infoItem}>
            <Icon name="marker" className={styles.infoIcon} />
            <Markup className={styles.infoDescription}>{address}</Markup>
          </div>
        </section>
        <LocationMap className={styles.mapSection} />
      </div>
    </Container>
  );
}
